import { Component, Injector, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { NotificationsService } from '@mt-ng2/notifications-module';
import { AuthService } from '@mt-ng2/auth-module';
import { PageTitlesService } from '@mt-ng2/page-titles';

@Component({
    selector: 'app-admin-access',
    templateUrl: './admin-access.component.html',
})
export class AdminAccessComponent implements OnInit {
    resetPasswordForm: FormGroup;
    resetKey: string;
    badKeyError = `Oops something went wrong!
    - Probably the key has been used or expired.
    - Or you did something you weren't supposed to do.
    - Your best bet is to just generate a new email.`;

    protected authService: AuthService;
    protected router: Router;
    public route: ActivatedRoute;
    protected notificationsService: NotificationsService;
    protected pageTitlesService: PageTitlesService;

    constructor(injector: Injector) {
        this.authService = injector.get(AuthService);
        this.router = injector.get(Router);
        this.route = injector.get(ActivatedRoute);
        this.notificationsService = injector.get(NotificationsService);
        this.pageTitlesService = injector.get(PageTitlesService);
    }

    ngOnInit(): void {
        this.route.queryParams.subscribe((params) => {
            this.resetKey = params.resetKey;
        });
        this.authService.adminAccess(this.resetKey).subscribe(
            (answer) => {
                this.success();
                this.router.navigate(['/home']);
            },
            (error) => {
                if (error.status === 418) {
                    this.notificationsService.error('Access link is invalid');
                    console.error(this.badKeyError);
                } else if (error.status === 400) {
                    // TODO: Can we just inject the error service?
                    if (error.error) {
                        this.error(error.error.ModelState.Service);
                    } else {
                        this.error('Something went wrong, Please generate a new access email');
                        console.error(this.badKeyError);
                    }
                }
            },
        );
        this.setPageTitle();
    }

    setPageTitle(): void {
        this.pageTitlesService.setPageTitle('Admin Access');
    }

    error(msg?: string): void {
        if (!msg) {
            this.notificationsService.error('Save Failed');
        } else {
            this.notificationsService.error(msg);
        }
    }

    success(): void {
        this.notificationsService.success('Welcome Miles User!');
    }
}
